import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

// Custom components
import Sidebar from "../../Sidebar/Sidebar";
import BodyCard from "../../BodyCard/BodyCard";
import MobileHeader from "../../MobileHeader/MobileHeader";

const ClinicalDashboardLayout = () => {
  // Verify if user if authenticated
  const { isAuthenticated } = useAuth();

  const location = useLocation();

  return isAuthenticated ? (
    <div className="Xbg-neutral-300">
      <MobileHeader />
      <Sidebar />

      {/* Outlet is the children of Layout. Anything nested inside the Layout. */}
      <BodyCard>
        <Outlet />
      </BodyCard>
    </div>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default ClinicalDashboardLayout;
